const translation = {
  nav: {
    home: 'ホーム',
    about: '我々について',
    members: 'メンバー',
    blog: 'ブログ',
    consultation: '相談所',
    contact: 'お問い合わせ',
  },
  // Navigation
  'nav.home': 'ホーム',
  'nav.members': 'メンバー',
  'nav.blog': 'ブログ',
  'nav.contact': 'お問い合わせ',
  'nav.language': '言語',

  // Hero Section
  'hero.title': '地域と共に創る未来',
  'hero.subtitle': 'Yoshino Village Project',
  'hero.description': '持続可能な地域発展を目指すコミュニティ共創プロジェクト。地域交流、環境保全、人材育成を通じて、吉野の未来を共に創ります。',
  'hero.cta.learn': '詳しく見る',
  'hero.cta.join': '参加する',

  // About Section
  'about.title': 'プロジェクトについて',
  'about.subtitle': 'Yoshino Village Project',
  'about.description': 'Yoshino Village Projectは、持続可能な地域発展を目指すコミュニティ共創プロジェクトです。地域交流、環境保全、人材育成を通じて、吉野の未来を共に創ります。',
  'about.vision.title': 'ビジョン',
  'about.vision.description': '人と自然が調和する持続可能なコミュニティを創り、吉野の豊かな文化と自然を次世代に継承します。',
  'about.mission.title': 'ミッション',
  'about.mission.description': '地域住民と外部支援者の協働により、地域を活性化し、新たな価値を創造します。',
  'about.values.title': 'バリュー',
  'about.values.description': '多様性を尊重し、対話を大切にし、共に行動する。コミュニティ共創による持続可能な成長を目指します。',

  // Members Section
  'members.preview.title': 'プロジェクトメンバー',
  'members.preview.subtitle': 'チーム紹介',
  'members.preview.description': '様々なバックグラウンドと専門性を持つメンバーが、吉野の未来を共に創っています。',
  'members.preview.cta': 'すべてのメンバーを見る',
  'members.page.title': 'プロジェクトメンバー',
  'members.page.subtitle': 'チーム紹介',
  'members.page.description': '様々なバックグラウンドと専門性を持つメンバーが、吉野の未来を共に創っています。',

  // Blog Section
  'blog.preview.title': '最新の活動',
  'blog.preview.subtitle': 'ブログ',
  'blog.preview.description': '最新の活動報告やイベント情報をご覧ください。',
  'blog.preview.cta': 'すべての記事を見る',
  'blog.page.title': 'ブログ',
  'blog.page.subtitle': '活動報告・イベント情報',
  'blog.page.description': '最新の活動報告やイベント情報をご覧ください。',
  'blog.readMore': '続きを読む',
  'blog.backToList': 'ブログ一覧に戻る',

  // News Section
  'news.title': '最新情報',
  'news.subtitle': 'ニュース・お知らせ',
  'news.viewAll': 'すべてのニュースを見る',

  // Activities Section
  'activities.title': '3つの活動の柱',
  'activities.subtitle': '私たちの活動',
  'activities.community.title': '地域交流',
  'activities.community.description': '地域住民と外部支援者をつなぐイベントやワークショップを通じて、コミュニティの絆を強化します。',
  'activities.environment.title': '環境保全',
  'activities.environment.description': '森林保全や持続可能な農業を通じて、吉野の豊かな自然を次世代に継承します。',
  'activities.education.title': '人材育成',
  'activities.education.description': '教育プログラムやインターンシップを通じて、次世代のリーダーを育成します。',

  // Voices Section
  'voices.title': '参加者の声',
  'voices.subtitle': '体験談',

  // Join Section
  'join.title': '参加募集',
  'join.subtitle': 'メンバーになる',
  'join.description': '吉野の未来を共に創りたい方を募集しています。年齢、経験、居住地を問わず、どなたでも参加できます。',
  'join.volunteer.title': 'ボランティア',
  'join.volunteer.description': 'イベントや活動に参加。月1回からでも参加可能です。',
  'join.supporter.title': 'サポーター',
  'join.supporter.description': '寄付やスポンサーシップでプロジェクトを支援。',
  'join.partner.title': 'パートナー',
  'join.partner.description': '企業・団体としてパートナーシップを結ぶ。',
  'join.cta': 'お問い合わせ',

  // Social Section
  'social.title': 'ソーシャルメディア',
  'social.subtitle': 'フォローする',
  'social.instagram.title': 'Instagram',
  'social.instagram.description': '日々の活動や吉野の美しい風景をチェック',
  'social.youtube.title': 'YouTube',
  'social.youtube.description': 'プロジェクト紹介動画やイベントレポートを視聴',

  // Contact Page
  'contact.title': 'お問い合わせ',
  'contact.subtitle': 'ご連絡ください',
  'contact.description': 'プロジェクトに関するご質問、参加のお問い合わせ、協力のご提案など、お気軽にご連絡ください。',
  'contact.form.title': 'お問い合わせフォーム',
  'contact.form.name': 'お名前',
  'contact.form.name.placeholder': '山田太郎',
  'contact.form.email': 'メールアドレス',
  'contact.form.email.placeholder': 'example@email.com',
  'contact.form.subject': '件名',
  'contact.form.subject.placeholder': '件名を入力してください',
  'contact.form.message': 'メッセージ',
  'contact.form.message.placeholder': 'メッセージを入力してください',
  'contact.form.submit': '送信',
  'contact.form.submitting': '送信中...',
  'contact.form.success': 'メッセージが送信されました。担当者より折り返しご連絡いたします。',
  'contact.form.error': '送信に失敗しました。もう一度お試しください。',
  'contact.info.title': '連絡先情報',
  'contact.info.address': '住所',
  'contact.info.email': 'メール',
  'contact.info.phone': '電話',
  'contact.access.title': 'アクセス',

  // Footer
  'footer.description': '持続可能な地域発展を目指すコミュニティ共創プロジェクト',
  'footer.quickLinks': 'クイックリンク',
  'footer.followUs': 'フォローする',
  'footer.newsletter.title': 'ニュースレター',
  'footer.newsletter.description': '最新情報を受け取る',
  'footer.newsletter.placeholder': 'メールアドレスを入力',
  'footer.newsletter.subscribe': '登録',
  'footer.newsletter.success': '登録が完了しました！',
  'footer.newsletter.error': '登録に失敗しました。もう一度お試しください。',
  'footer.copyright': '© 2024 Yoshino Village Project. All rights reserved.',

  // 404 Page
  'notFound.title': 'ページが見つかりません',
  'notFound.description': 'お探しのページは存在しません。',
  'notFound.backHome': 'ホームに戻る',

  // Common
  'common.readMore': '続きを読む',
  'common.learnMore': '詳しく見る',
  'common.viewAll': 'すべて見る',
  'common.close': '閉じる',
  'common.loading': '読み込み中...',
  
  // About Page
  aboutPage: {
    hero: {
      title: '我々について',
      subtitle: 'Yoshino Village Network',
      description: '挑戦する人と地域が出会う場所',
    },
    whatIsYVN: {
      title: 'Yoshino Village Networkとは',
      description1: 'Yoshino Village Networkは、奈良県吉野町を舞台に、地域に関わりたい人と地域をつなぐプラットフォームです。',
      description2: '完成したプロジェクトを見せるサイトではありません。進行中の挑戦、試行錯誤、可能性を共有する場所です。',
      description3: 'ここは「参加のきっかけ」を作る場所です。',
    },
    whyStarted: {
      title: 'なぜ始めたのか',
      challenges: {
        title: '吉野が抱える課題',
        description1: '吉野町は、美しい自然と豊かな歴史を持つ地域です。しかし、多くの地方と同様に、人口減少、高齢化、若者の流出といった課題に直面しています。',
        description2: '特に深刻なのは、若者が定住できる仕事の不足です。地元に残りたいと思っても、生活の基盤を築くことが難しい状況があります。',
      },
      answer: {
        title: '私たちの答え',
        description1: 'この課題に対して、私たちは「外から人を呼び込むだけでは足りない」と考えました。',
        description2: '必要なのは、「仕事」を生み出し、「価値」を生み出し、地域に「誇り」を取り戻すこと。',
        description3: 'そのためには、地域住民も、移住者も、訪問者も、みんなが対等に関わり、共に挑戦できる場が必要だと考えました。',
      },
    },
    activities: {
      title: '私たちの活動',
      gateway: {
        title: '入口づくり',
        description: '「吉野、気になる」から「吉野に関わっている」へ。様々な「入口」を用意し、興味を持った人が具体的なアクションを起こせるようにしています。相談サービス、イベント、プロジェクト参加など、関わり方は人それぞれです。',
      },
      jobs: {
        title: '仕事づくり',
        description: '若者が定住できる仕事を生み出すため、地域の資源を活かした新しい事業の立ち上げや、既存産業の活性化に取り組んでいます。林業、建築、食など、様々な分野で挑戦しています。',
      },
      community: {
        title: 'コミュニティ形成',
        description: '地域住民、移住者、訪問者が対等に関われる場を作っています。定期的な会議やイベントを通じて、互いに学び合い、支え合うコミュニティを育てています。',
      },
      information: {
        title: '情報発信',
        description: '吉野で起きている挑戦や試行錯誤をリアルタイムで発信しています。成功だけでなく、失敗や課題も共有することで、透明性と信頼を大切にしています。',
      },
    },
    values: {
      title: '私たちの価値観',
      experimental: {
        title: '実験中',
        description: '完璧を目指さず、まずやってみる。失敗も含めて共有し、そこから学ぶことを大切にしています。',
      },
      workInProgress: {
        title: '未完成',
        description: '完成品ではなく、進行中のプロセスを大切にしています。今来た人が設計に関われる余白を残しています。',
      },
      equal: {
        title: '対等',
        description: '地域住民も、移住者も、訪問者も、みんなが対等。立場に関係なく、共に挑戦する仲間です。',
      },
    },
    members: {
      title: '吉野に集まる人たち',
      subtitle: '様々なバックグラウンドを持つ人たちが、それぞれの形で吉野に関わっています',
      readStory: 'ストーリーを読む',
    },
    vision: {
      title: '私たちが目指すもの',
      settlement: {
        title: '若者が定住できる地域',
        description: '魅力的な仕事があり、生活の基盤を築ける地域を目指しています。地域の資源を活かした新しい産業を生み出し、若者が住みたいと思える環境を作ります。',
      },
      pride: {
        title: '地域に誇りを持てる社会',
        description: '地域の人が、自分たちの文化や技術、自然に自信を持ち、次世代に継承していける社会を目指しています。外からの評価に頼らない、内側から湧き上がる誇りを大切にします。',
      },
      diverse: {
        title: '多様な人が関われる場',
        description: '地域住民も、移住者も、訪問者も、立場や背景に関係なく、誰もが対等に関われる場を目指しています。「消費者」から「生産者」へ、「観客」から「参加者」へ。共に挑戦する仲間を増やしていきます。',
      },
    },
    cta: {
      title: '吉野に関わってみたい？',
      description: '「何から始めればいいかわからない」「自分に何ができるか知りたい」そんな相談、大歓迎です。',
      button: '吉野なんでも相談所に相談する',
      responseTime: '返信目安：2〜3営業日',
    },
  },
  
  thisWeek: {
    title: '今週のYoshino Village',
    subtitle: 'リアルタイムで動いていること、参加できること',
    schedule: '今週の予定',
    updates: '最近の動き',
    moreOnInstagram: 'もっと詳しい活動状況はInstagramで',
  },
  
  gateway: {
    title: '吉野なんでも相談所',
    subtitle: '「ちょっと気になる」から「本気で移住したい」まで。どんな相談でもOK。',
    description: '実際に吉野で活動しているメンバーが、リアルな情報をお伝えします。',
    chooseMethod: '相談方法を選んでください',
    replyTime: '返信は通常24時間以内。気軽にどうぞ！',
    contactForm: 'フォームで相談',
    chatConsultation: 'チャットで相談',
    comingSoon: '準備中',
    tip: 'まずは気軽にオンライン雑談会に参加してみるのもおすすめです（毎週水曜19:00〜）',
  },
  
  instagram: {
    title: 'リアルな日常',
    subtitle: '#YoshinoVillageProject の投稿から、飾らない活動の様子をお届け',
    viewAll: 'Instagramで全ての投稿を見る',
  },
  
  youtube: {
    title: '人が語る、リアルな吉野',
    subtitle: '移住者、地元の方、挑戦者たち。それぞれの視点から見た吉野の今',
    viewChannel: 'YouTubeチャンネルを見る',
  },
  
  results: {
    title: '数字で見る実績',
    subtitle: '小さくても、確実に動いています',
    projectsTitle: '今、動いているプロジェクト',
    projectsSubtitle: 'あなたも参加できるかもしれません',
    progress: '進捗',
    viewDetails: '詳細を見る',
  },
  
  honestVoices: {
    title: 'リアルな声（正直版）',
    subtitle: '良いことも、大変なことも。飾らずに伝えます',
    notSuitable: '正直、こんな人には向いていません',
    notSuitableDesc: 'ミスマッチを防ぐために、先に伝えておきます',
    tip: 'でも、「挑戦してみたい」という気持ちがあれば、まずは相談してください',
  },
} as const;

export default translation;